import React from 'react';
import ProjectContent from '../components/ProjectContent';

const Keylogger = () => <ProjectContent projectName='Keylogger'/>;

export default Keylogger;